module.exports = __webpack_public_path__ + "static/media/fly0275.d5c85d23.webp";